import React, { useState, useEffect } from 'react'
import { useDispatch , useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import {CardMedia,
    Button,
    List,
    Divider,
    ListItemText ,
    Grid,
    InputLabel,
    Select,
    MenuItem,
    FormControl,TextField } from '@mui/material'
import Rated from '../components/Rated'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { listProductDetails } from '../actions/productActions'
import Alert from '@mui/material/Alert';

const ProductScreen = ({history, match })  => {
    // const product = products.find((p) =>p._id === match.params.id)
    const [qty, setQty] = useState(0)
    const dispatch = useDispatch()

    const productDetails = useSelector((state) => state.productDetails)
    const { loading, error, product ,gambar,data_act} = productDetails
    // console.log(gambar)

    useEffect(()=>{
     dispatch(listProductDetails(match.params.id))
    }, [dispatch,match])

    const addToCartHandler = () => {
        history.push(`/cart/${match.params.id}?qty=${qty}`)
      }



    return (
        <>

        <Grid container spacing={3} sx={{ mt: 8 }}>
            <Grid item xs={12}>
                {/* <Link to='/'>
                    <Button variant="contained">GO BACK</Button>
                </Link> */}
                <Link to='/'>

                    <Button size="small" color="primary" >
                    GO BACK
                    </Button>

                </Link>
            </Grid>
            {loading ? (
                <Loader />
                ) : error ? (

                    <Alert severity="error" variant="filled">{error}</Alert>
                ) : (
             
            <>
                
                <Grid item xs={6}>
                    
                    <CardMedia
                        component="img"
                        alt={product.name}
                        image= {'/images/'+gambar}

                        title={product.name}
                    
                    />

        
                </Grid>
                <Grid item xs={3}>
                        <List component="nav" aria-label="secondary mailbox folders">
                        <ListItemText primary={product.name}/>

                        </List>
                        <Divider /> 
                        <List component="nav" aria-label="secondary mailbox folders">
                            <Rated
                                value={product.rating}
                                text={`${product.numReviews} Rating`}
                                classname='countReview'
                            />
                        </List>   
                        <Divider /> 
                        <List component="nav" aria-label="secondary mailbox folders">
                            <ListItemText primary={product.content}/>
                        </List>
                        
                </Grid>

                <Grid item xs={3}>

                        <List component="nav" aria-label="secondary mailbox folders">
                            <ListItemText primary={"Price : $"+product.product_price}/>
                        </List>
            
                        <Divider /> 
                        <List component="nav" aria-label="secondary mailbox folders">
                            <ListItemText primary={product.product_last_stock > 0 ? "Status : In stock":"Status : Out of Stock"}/>
                        </List>
                        <Divider />
                        <Grid container spacing={0} >
                            {/* <Grid item xs={3}>
                                <InputLabel htmlFor="my-input">Jumlah :</InputLabel>
                            </Grid> */}
                            <Grid item xs={9}>

                            
                            {product.product_last_stock > 0 && (
                                <FormControl>
                                    <TextField
                                        id="outlined-number"
                                        label="Jumlah"
                                        type="number"
                                        value={qty}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{ inputProps: { min: 0, max: product.product_last_stock } }}
                                        onChange ={(e) => {

                                            var value = Number(e.target.value);
                                            if (value > product.product_last_stock) value = product.product_last_stock;
                                            if (value < 1) value = 1;
                                            setQty(value)
                                        }}

                                    />
                                    
                                    {/* <Select
                                    value={qty}
                                    onChange={(e) => setQty(e.target.value)}
                                    displayEmpty
                                    //   className={classes.selectEmpty}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    >
                                        {[...Array(product.product_last_stock).keys()].map(
                                                        (x) => (
                                                            <MenuItem  key={x + 1} value={x + 1}>
                                                            {x + 1}
                                                            </MenuItem >
                                                        )
                                                        )}
                                                    
                                    </Select> */}
                                </FormControl>
                            )}
                            </Grid> 

                        </Grid>
                        

                        <Divider />
                        <List component="nav" aria-label="secondary mailbox folders">
                            <Button variant="contained" color="primary" 
                            onClick={addToCartHandler}
                            disabled={product.product_last_stock === 0}
                            >Add to Chart
                            </Button>
                        </List>
                        {/* {data_act.map((producttt) => (
                            <p>{producttt.image_url}</p>
                        ))} */}
                </Grid>





            </>
            )}

        </Grid>
    </>

    )
}

export default ProductScreen
